import { UserFrontPrivate } from "@project/shared-types";
import { createContext, useEffect, useMemo } from "react";
import { sendMetrics } from '../../../shared/hooks/sendMetrics';
import { IdentifyUser } from "../../../shared/hooks/sendTack";
import { useLocalStorage } from "../../../shared/hooks/useLocalStorage";
import { GetUserPrivateAPI } from "./user.api";

// Создаем контекст для авторизованного пользователя
export const UserContext = createContext<{
  user: UserFrontPrivate | null;
  setUser: (user: UserFrontPrivate | null) => void;
  token: string | null;
  login: (token: string, is_system_login: boolean) => Promise<void>;
  logout: () => Promise<void>;
  isAuthorized: boolean;
}>(null!);

/**
 * UserProvider - компонент-провайдер для хранения данных
 * об авторизованном пользователе.
 *
 * Использует хук useLocalStorage для сохранения данных
 * между сессиями в localStorage.
 *
 * @param props.children - дочерние компоненты, которые будут иметь
 * доступ к контексту пользователя
 */
export const UserProvider = ({ ...props }) => {
  const [user, setUser] = useLocalStorage<UserFrontPrivate | null>(
    "user_auth",
    null
  );
  const [token, setToken] = useLocalStorage<string | null>("token", null);

  const isAuthorized = useMemo(() => {
    return token != null;
  }, [token]);

  const getUserPrivate = async () => {
    const response = await GetUserPrivateAPI({});
    if (response.user) {
      setUser(response.user);
      IdentifyUser(response.user.id, {
        email: response.user.email,
      });
    }
  };

  useEffect(() => {
    if (isAuthorized) {
      getUserPrivate();
    }
  }, [isAuthorized]);


  const login = async (token: string, is_system_login: boolean = false) => {
    setToken(token);
    if (!is_system_login) {
      sendMetrics("reachGoal", "login_succses");
    }
    else {
      sendMetrics("reachGoal", "login_system");
    }
  }
  const logout = async () => {
    setToken(null);
    setUser(null);
    sendMetrics("reachGoal", "login_logout");
  }

  return (
    <UserContext.Provider value={{ user, setUser, token, login, logout, isAuthorized }}>
      {props.children}
    </UserContext.Provider>
  );
};
